&nbsp; <span class="bhptooltip" style="position: absolute;" (mouseenter)="onHover()" (mouseleave)="onLeaving()" >
  <p class="no-events" *ngIf="mounted && !!text" [ngClass]="show ? 'showed' : 'hiden'">
    <ng-container *ngIf="mounted">
      <ng-container *ngFor="let text of splitBreakLines(text)">
        <span *ngIf="text !== ''" style="margin-top: 0; margin-bottom: 0">
          {{text}}
        </span>
        <ng-container *ngIf="text === ''">
          <br>
          <br>
        </ng-container>
      </ng-container>
    </ng-container>
  </p>
</span>
